import dexoraLogo from "../assets/logo/dexo.png";
import dxudLogo from "../assets/logo/dxud.png";

export const list = [
    {
        name: "DEXO",
        img: dexoraLogo,
        status: true,
        count: 0,
        symbol: "DEXO",
        address: "0xc3DC96C470F010a5B07d27601acF0f1E51E02F1c",
        decimals: 18,
    },
    {
        name: "DXUD",
        img: dxudLogo,
        status: true,
        count: 0,
        symbol: "DXUD",
        address: "0xAaA7Ab37C3A94CAA1e106cb0Fb845844CBAf70f4",
        decimals: 18,
    },
    {
        name: "USDC",
        img: "https://raw.githubusercontent.com/dhavalmp194/crypto-icons/refs/heads/main/cryptocurrency-icons-master/128/icon/usdc.png",
        status: true,
        count: 0,
        symbol: "USDC",
        address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
        decimals: 18,
    },
];
